<template id="packing-mode">
    <span title="Packing Mode" v-b-popover.hover.top="'Pack Status Of Order'">
        <b-badge variant="success"
                 v-if="order.misc?.doublePack === true">
            <font-awesome-icon :icon="['fas','cubes']"></font-awesome-icon> Double
        </b-badge>
        <b-badge variant="primary" v-else>
            <font-awesome-icon :icon="['fas','cube']"></font-awesome-icon> Single
        </b-badge>
    </span>
</template>
<script>
export default {
  name: 'OrderPack',
  data: () => ({}),
  props: {
    order: Object
  },
  created: function () {
  },
  computed: {},
  methods: {
  }
}
</script>
<style>
</style>